import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavVisibilityService {
  private readonly navHiddenSubject = new BehaviorSubject<boolean>(false);

  readonly navHidden$ = this.navHiddenSubject.asObservable();

  setNavHidden(hidden: boolean): void {
    this.navHiddenSubject.next(!!hidden);
  }
}
